import { createSlice } from '@reduxjs/toolkit';
import fetchChatLinks from '../thunk/chat-link-thunk';

// Initial state
const initialState = {
  usernames: {
    whatsapp: '+8801404452444',
    facebook: 'Singer.Bangladesh',
  },
  isLoading: false,
  error: null,
  openChatPopup: true,
  openChatMenu: false,
};

// Slice
const chatLinkSlice = createSlice({
  name: 'chat-link',
  initialState,
  reducers: {
    reset: (state) => {
      state.usernames = {
        whatsapp: '',
        facebook: '',
      };
      state.isLoading = true;
      state.error = null;
    },
    handleChatMenu: (state) => {
      state.openChatMenu = !state.openChatMenu;
    },
    handleChatPopup: (state) => {
      state.openChatPopup = !state.openChatPopup;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatLinks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchChatLinks.fulfilled, (state, action) => {
        if (action.payload?.usernames) {
          state.usernames = action.payload?.usernames;
        }
        state.isLoading = false;
      })
      .addCase(fetchChatLinks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { handleChatMenu, handleChatPopup, reset } = chatLinkSlice.actions;

export default chatLinkSlice.reducer;
